import React from 'react'
import { IconButton } from '@mui/material';
import { doc, updateDoc } from "firebase/firestore";
import { db } from '../../Components/Firebase/firebase.config'
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';

const RequestListItem = ({data, setVotes, user}) => {
  const userHasLiked = data.hasLiked.includes(user.uid);
  const userHasDisliked = data.hasDisliked.includes(user.uid);
  const [buttonDisabled, setButtonDisabled] = React.useState(false)

  const handleLike = async () => {
    setVotes(true)
    const washingtonRef = doc(db, "request", data.id);

    await updateDoc(washingtonRef, {
      likes: data.likes+1
    });
    await updateDoc(washingtonRef, {
      hasLiked: [...data.hasLiked, user.uid]
    });

    if(userHasDisliked){
      await updateDoc(washingtonRef, {
        hasDisliked: data.hasDisliked.filter(item => item !== user.uid),
        dislikes: data.dislikes -1
      });
    }

    setButtonDisabled(true)
    setVotes(false)
  }

  const handleDislike = async ()=> {
    setVotes(true)
    const washingtonRef = doc(db, "request", data.id);

    await updateDoc(washingtonRef, {
      dislikes:data.dislikes+1
    });
    await updateDoc(washingtonRef, {
      hasDisliked: [...data.hasDisliked, user.uid]
    });

    if(userHasLiked){
      await updateDoc(washingtonRef, {
        hasLiked: data.hasLiked.filter(item => item !== user.uid),
        likes: data.likes -1
      });
    }
    
    setButtonDisabled(true)
    setVotes(false)
  }
  
  return (
    <div className="listItems">
    <div className="requestListItem">
      <div className="userinfo">
        <div className="name">
          {data.name}
        </div>
        <div className="email">
          {data.email}
        </div>
      </div>
      <div className="courseInfo">
        <div className="courseDetails">
          <div className="courseName">
            {data.courseName}
          </div>
          <div className="courseLink" >
            {data.courseLink}
          </div>
        </div>
        <div className="likesection">
          <div className="likesCount">
          <IconButton aria-label="delete" disabled={userHasLiked} onClick={handleLike}>
          <ThumbUpIcon style={{color: 'green'}} />
          </IconButton>
            <div className="likes">{data.likes}</div>
          </div>
          <div className="dislikeCount">
          <IconButton aria-label="delete" disabled={userHasDisliked} onClick={handleDislike}>
          <ThumbDownIcon style={{color: 'red'}} />
          </IconButton>
          <div className="likes">{data.dislikes}</div>
          </div>
        </div>
      </div>
      
    </div>
    </div>
  )
}

export default RequestListItem